// Mock for @react-native-firebase modules on web
// These modules are not compatible with web, so we provide empty mocks
// The actual Firebase functionality for web is handled by firebase/app, firebase/auth, etc.

const noop = () => {};

const mockFirebaseModule = {
  default: () => ({
    onAuthStateChanged: noop,
    signInWithEmailAndPassword: noop,
    createUserWithEmailAndPassword: noop,
    signOut: noop,
    sendPasswordResetEmail: noop,
    collection: noop,
    doc: noop,
    getDoc: noop,
    setDoc: noop,
    updateDoc: noop,
    addDoc: noop,
    getDocs: noop,
    query: noop,
    where: noop,
    orderBy: noop,
    limit: noop,
    onSnapshot: noop,
    requestPermission: noop,
    getToken: noop,
    onMessage: noop,
    onTokenRefresh: noop,
    onNotificationOpenedApp: noop,
    getInitialNotification: noop,
  }),
  FirebaseAuthTypes: {},
};

module.exports = mockFirebaseModule;
